import { getAppType } from "@funded-here-interface/common/src/constant/appType";
import { getBaseUrl, Microservice } from "@funded-here-interface/common/src/constant/baseUrl";
import { isSessionInvalidatedError } from "@funded-here-interface/common/src/constant/sessionConstants";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { setLoggingOut } from "@funded-here-interface/common/src/Utils/axiosSessionInterceptor";
import axios from "axios";

import { LogoutRequest } from "../types/logout.type";

/**
 * Calls the logout API and manages the setLoggingOut flag.
 * State cleanup (Redux, storage, etc.) is handled by the caller
 * via performLogoutCleanup in the onSuccess callback.
 */
const logout = async ({ token, userId }: LogoutRequest) => {
  // Set flag to suppress session invalidation toast during intentional logout
  setLoggingOut(true);

  const appType = getAppType();

  try {
    await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(appType && { "X-App-Type": appType }),
          ...(userId && { "X-Active-User": userId }),
        },
      },
    );
  } catch (e) {
    // If session is already invalidated, that's fine - the caller will still clean up
    const message = getApiResponseErrorMsg(e);
    if (!isSessionInvalidatedError(message)) {
      throw new Error(message);
    }
    // For session invalidation errors, continue normally
  } finally {
    setLoggingOut(false);
  }
};

export default logout;
